module.exports = __webpack_public_path__ + "img/@logo_titleist@3x.b32f39e1.png";